import type {
	InvoiceSpec,
	KeyboardButton,
	MediaKind,
	MediaRef,
	ReplyKeyboard,
	SessionState,
	TraceEffect,
} from "@velizhanin-dev/bot-scenario"
import { apiClient } from "@/shared/api/client"
import { scenarioPath } from "./keys"

// --- тест-чат ---

export type TestChatEntry =
	| { id: string; at: string; from: "user"; text: string }
	| { id: string; at: string; from: "system"; text: string }
	| {
			id: string
			at: string
			from: "bot"
			nodeId: string
			/** HTML в разметке Telegram. */
			text: string
			media?: MediaRef
			gallery?: MediaRef[]
			keyboard?: KeyboardButton[][]
			replyKeyboard?: ReplyKeyboard
			removeKeyboard?: boolean
			invoice?: InvoiceSpec
	  }

export interface TestChatState {
	revision: number
	session: SessionState | null
	transcript: TestChatEntry[]
	pendingWakeup: { nodeId: string; epoch: number; runAt: string } | null
	/** Только в ответе на событие: по каким блокам прошёл движок. */
	traces?: TraceEffect[]
}

export type TestEvent =
	| { type: "start"; payload?: string }
	| { type: "text"; text: string }
	| { type: "button"; callbackData: string }
	| { type: "wakeup"; elapsed?: boolean }
	| { type: "play"; nodeId: string }
	| { type: "contact"; phone: string }
	| { type: "location"; latitude: number; longitude: number }
	| { type: "media"; mediaKind: MediaKind; fileName?: string }
	| { type: "payment"; nodeId: string }

export const getTestChat = async (id: string) =>
	(await apiClient.get<TestChatState>(scenarioPath(id, "/test/state"))).data

export const sendTestEvent = async (id: string, event: TestEvent) =>
	(await apiClient.post<TestChatState>(scenarioPath(id, "/test/events"), event)).data

export const resetTestChat = async (id: string) =>
	(await apiClient.post<TestChatState>(scenarioPath(id, "/test/reset"))).data
